import { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import List from './pages/List';

const MediaDiagnostics: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}`} component={List} />
    </Switch>
  );
};

export default MediaDiagnostics;
